import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from './../assets/img/logo.svg';


function Default(props) {

    const handleLangChange = () => {
        props.onChangeHandleMenu();
    }


    return (
        <>
            <aside id="layout-menu" className="layout-menu menu-vertical menu bg-menu-theme">
                <div className="app-brand demo mt-3 mb-3 text-center">
                    <Link to="/dashboard" className="app-brand-link" style={{ "margin": "0px auto" }}>
                        <img src={Logo} alt='Logo' width="100px" />
                    </Link>
                    <Link onClick={handleLangChange} to="#"
                        className="layout-menu-toggle menu-link text-large ms-auto d-block d-xl-none">
                        <i className="bx bx-chevron-left bx-sm align-middle"></i>
                    </Link>
                </div>

                <div className="menu-inner-shadow"></div>

                <ul className="menu-inner py-1 overflow-auto">
                    <li className="menu-item">
                        <NavLink exact="true" to="/dashboard" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-home-circle"></i>
                            <div data-i18n="Email">Dashboards</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/users" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-user"></i>
                            <div data-i18n="Email">Users</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/orders" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-cart"></i>
                            <div data-i18n="Email">Orders</div>
                        </NavLink>
                    </li>


                    <li className="menu-item">
                        <NavLink exact="true" to="/products" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-package"></i>
                            <div data-i18n="Email">Products</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/reviews" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-star"></i>
                            <div data-i18n="Email">Reviews</div>
                        </NavLink>
                    </li>
                    <li className="menu-item">
                        <Link href="#" className="menu-link menu-toggle collapsed" data-bs-toggle="collapse" data-bs-target="#navbarToggleSmm">
                            <i className="menu-icon tf-icons bx bx-list-ul"></i>
                            <div data-i18n="Dashboards">Product Settings</div>
                        </Link>
                        <ul className="menu-sub collapse" id="navbarToggleSmm">
                            <li className="menu-item">
                                <NavLink to="items" className="menu-link">
                                    <div>Items</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="size" className="menu-link">
                                    <div>Size</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="/karates" className="menu-link">
                                    <div>Carat</div>
                                </NavLink>
                            </li>
                            <li className="menu-item">
                                <NavLink to="shades" className="menu-link">
                                    <div>Shades</div>
                                </NavLink>
                            </li>
                            {/* <li className="menu-item">
                                <NavLink to="stones" className="menu-link">
                                    <div>Stones</div>
                                </NavLink>
                            </li> */}
                            <li className="menu-item">
                                <NavLink to="categories" className="menu-link">
                                    <div>Categories</div>
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    <li className="menu-item">
                        <NavLink exact="true" to="/setting" className="menu-link">
                            <i className="menu-icon tf-icons bx bx-cog"></i>
                            <div data-i18n="Email">Settings</div>
                        </NavLink>
                    </li>
                </ul>
            </aside>
        </>
    );
}

export default Default;